import React, { useState, useEffect } from 'react';
import { AdUnit } from '../components/AdUnit';

const AD_SLOT_IN_ARTICLE = '4728259285'; // In-article – fluid

export function AboutPage() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const res = await fetch('https://should-i-get-reparations-backend.vercel.app/api/pages/about');
      const data = await res.json();
      if (data.success) {
        setContent(data.data);
      }
    } catch (err) {
      console.error('Failed to fetch about content:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Loading…</div>;

  return (
    <div>
      <h1>{content?.title || 'About'}</h1>
      <div dangerouslySetInnerHTML={{ __html: content?.content || 'This site allows users to vote on reparations eligibility for educational purposes.' }} />
      {/* In-article ad after the content */}
      <AdUnit slot={AD_SLOT_IN_ARTICLE} format="fluid" layout="in-article" />
    </div>
  );
}
